import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Home from "./Pages/Public/Home";
import CompetitionTerms from "./Pages/Public/CompetitionTerms";
import Login from './Pages/CMS/Login';
import Dashboard from "./Pages/CMS/Dashboard";
import ForgotPassword from "./Pages/CMS/ForgotPassword";
import ResetPassword from "./Pages/CMS/ResetPassword";
import AdminUsers from "./Pages/CMS/AdminUsers";
import AdminPageHeaders from "./Pages/CMS/AdminPageHeader";
import AdminHome from "./Pages/CMS/AdminHome";
import AdminAboutUs from "./Pages/CMS/AdminAboutUs";
import AdminProducts from "./Pages/CMS/AdminProducts";
import AdminHowTo from "./Pages/CMS/AdminHowTo";
import AdminRecipes from "./Pages/CMS/AdminRecipes";
import AdminRetailer from "./Pages/CMS/AdminRetailer";
import AdminBlogs from "./Pages/CMS/AdminBlogs";
import AboutUs from "./Pages/Public/AboutUs";
import Products from "./Pages/Public/Products";
import Blogs from "./Pages/Public/Blogs";
import ContactUs from "./Pages/Public/ContactUs";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/competition-terms-and-conditions" element={<CompetitionTerms />} />
                {/*<Route path="/about-us" element={<AboutUs />} />*/}
                {/*<Route path="products" element={<Products />} />*/}
                {/*<Route path="/news" element={<Blogs />} />*/}
                {/*<Route path="/news/:slug" element={<Blogs />} />*/}
                {/*<Route path="/contact-us" element={<ContactUs />} />*/}

                {/*<Route path="/admin-login" element={<Login />} />*/}
                {/*<Route path="/admin-dashboard" element={<Dashboard />} />*/}
                {/*<Route path="forgot-password" element={<ForgotPassword />} />*/}
                {/*<Route path="/reset-password" element={<ResetPassword />}/>*/}
                {/*<Route path="/admin-users" element={<AdminUsers />} />*/}
                {/*<Route path="/admin-page-headers" element={<AdminPageHeaders />} />*/}
                {/*<Route path="/admin-home" element={<AdminHome />} />*/}
                {/*<Route path="/admin-about-us" element={<AdminAboutUs />} />*/}
                {/*<Route path="/admin-products" element={<AdminProducts />} />*/}
                {/*<Route path="/admin-how-to/" element={<AdminHowTo />} />*/}
                {/*<Route path="/admin-recipes" element={<AdminRecipes />} />*/}
                {/*<Route path="/admin-retailers" element={<AdminRetailer />} />*/}
                {/*<Route path="/admin-blogs" element={<AdminBlogs />} />*/}

                {/* Any other URL → Home */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
